(function(){ if (window.SoulyshineGazeMap && window.SoulyshineGazeMap.handle === 'blooming-memories-petite-botanical-flower-charm-and-polyester-cord-bracelet-set') return;
  'use strict';

  if (window.__soulyshineStandingDogProductUiInstalled) return;
  window.__soulyshineStandingDogProductUiInstalled = true;

  var containerSelector = [
    '.main-product-section .product-form__input--option-material',
    '.main-product-section .product-form__input--material-fallback'
  ].join(',');
  var refreshQueued = false;

  function itemForInput(track, input) {
    if (!track || !input) return null;
    return input.closest('.color-swatch') || track.querySelector('label[for="' + CSS.escape(input.id) + '"]');
  }

  function materialItems(track) {
    return Array.prototype.filter.call(track.children, function (child) {
      return child.matches('label[data-option-value], .color-swatch');
    });
  }

  function ensureTrack(container) {
    if (!container) return null;

    var track = container.querySelector(':scope > .color-swatches-container, :scope > .ss-material-slider-track');
    if (!track) {
      var inputs = Array.prototype.slice.call(
        container.querySelectorAll(':scope > input[type="radio"][name="Material"]')
      );
      if (!inputs.length) return null;

      track = document.createElement('div');
      track.className = 'ss-material-slider-track';
      var heading = container.querySelector(':scope > .product-form__label-container');
      if (heading) {
        heading.insertAdjacentElement('afterend', track);
      } else {
        container.insertBefore(track, inputs[0]);
      }

      inputs.forEach(function (input) {
        var label = container.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        track.appendChild(input);
        if (label) track.appendChild(label);
      });
    }

    track.classList.add('ss-standing-dog-material-track');
    materialItems(track).forEach(function (item) {
      item.style.setProperty('box-sizing', 'border-box', 'important');
      item.style.setProperty('flex', '0 0 96px', 'important');
      item.style.setProperty('margin', '0', 'important');
      item.style.setProperty('max-width', '96px', 'important');
      item.style.setProperty('min-width', '96px', 'important');
      item.style.setProperty('width', '96px', 'important');
    });
    container.classList.remove('ss-material-fit-mobile', 'ss-material-fit-desktop');
    container.classList.add('ss-material-overflow-mobile', 'ss-material-overflow-desktop');
    return track;
  }

  function revealSelected(container, smooth) {
    var track = ensureTrack(container);
    var input = container && container.querySelector('input[type="radio"][name="Material"]:checked');
    var item = itemForInput(track, input);
    if (!track || !item) return;

    var items = materialItems(track);
    var index = items.indexOf(item);
    if (index < 0) return;

    var itemStart = item.offsetLeft;
    var itemEnd = itemStart + item.offsetWidth;
    var viewStart = track.scrollLeft;
    var viewEnd = viewStart + track.clientWidth;
    if (itemStart >= viewStart && itemEnd <= viewEnd) return;

    var target = itemStart - Math.max(0, (track.clientWidth - item.offsetWidth) / 2);
    var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
    track.scrollTo({
      left: Math.min(maximum, Math.max(0, target)),
      behavior: smooth ? 'smooth' : 'auto'
    });
  }

  function refresh(root, reveal) {
    var scope = root && root.querySelectorAll ? root : document;
    var containers = [];
    if (scope.matches && scope.matches(containerSelector)) containers.push(scope);
    containers = containers.concat(Array.prototype.slice.call(scope.querySelectorAll(containerSelector)));

    containers.forEach(function (container) {
      ensureTrack(container);
      if (reveal) revealSelected(container, false);
    });
  }

  function queueRefresh(root, reveal) {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(function(){ if (window.SoulyshineGazeMap && window.SoulyshineGazeMap.handle === 'blooming-memories-petite-botanical-flower-charm-and-polyester-cord-bracelet-set') return;
      refreshQueued = false;
      refresh(root || document, reveal);
    });
  }

  document.addEventListener('soulyshine:variant:updated', function (event) {
    var picker = event.detail && event.detail.picker;
    queueRefresh((picker && picker.closest('.main-product-section')) || document, true);
  });

  document.addEventListener('shopify:section:load', function (event) {
    queueRefresh(event.target, true);
  });

  window.addEventListener('resize', function () {
    queueRefresh(document, true);
  });

  var observer = new MutationObserver(function (records) {
    var needsRefresh = records.some(function (record) {
      return Array.prototype.some.call(record.addedNodes, function (node) {
        return node.nodeType === 1 && (
          (node.matches && node.matches(containerSelector + ', [data-high-variant-picker="true"]')) ||
          (node.querySelector && node.querySelector(containerSelector))
        );
      });
    });
    if (needsRefresh) queueRefresh(document, true);
  });

  function start() {
    refresh(document, true);
    [100, 500, 1500].forEach(function (delay) {
      window.setTimeout(function(){ if (window.SoulyshineGazeMap && window.SoulyshineGazeMap.handle === 'blooming-memories-petite-botanical-flower-charm-and-polyester-cord-bracelet-set') return;
        refresh(document, true);
      }, delay);
    });
    var main = document.getElementById('MainContent') || document.body;
    if (main) observer.observe(main, { childList: true, subtree: true });
  }

  window.addEventListener('load', function () {
    refresh(document, true);
  }, { once: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
